<template>
  <div class="stationeryRecord-topbar">
    <div class="stationeryRecord-list-topbar">
      <div class="search-list">
        <div class="stationeryRecord-search" v-if="currentLabel != '我的申请'">
          <search placeholder="请输入申请教师名称" @search="teacherNameSearch" />
        </div>
        <div class="stationeryRecord-search" v-if="currentLabel == '申请统计'">
          <search placeholder="请输入申请物品" @search="stationeryNameSearch" />
        </div>
        <el-date-picker class="date" v-model="applyDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" @change="applyDateChange">
        </el-date-picker>
      </div>
      <div class="stationeryRecord-info-button-container">
        <button class="button add-stationeryRecord" @click="addStationeryRecordDialogShow"
          v-hasPermi="'sc:stationeryrecord:add'">
          <i class="iconfont icon-add"></i>新增申请
        </button>
      </div>
    </div>
    <div class="topbar-tabs">
      <div class="tab-item" :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in statusList" :key="index" @click="changeCurrentTabItem(item.value)">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";

export default {
  components: {
    search,
  },
  data() {
    return {
      currentCourseItem: 0,
      applyDate: ''
    };
  },
  props: {
    statusList: {
      type: Array,
      require: true,
    },
    currentLabel: {
      type: [String, Number]
    }
  },
  created() {
    // console.log(this.statusList);
  },
  methods: {
    // 切换状态
    changeCurrentTabItem(tabsIndex) {
      // console.log(tabsIndex);
      this.currentCourseItem = tabsIndex;
      // console.log(this.currentCourseItem);
      // 下标传值
      this.$emit("currentContentIndex", this.currentCourseItem);
    },
    stationeryNameSearch(e) {
      this.$emit("stationeryNameSearch", e);
    },
    teacherNameSearch(e) {
      this.$emit("searchTeacherName", e);
    },
    applyDateChange(date) {
      this.$emit("applyDateChange", date);
    },
    addStationeryRecordDialogShow() {
      this.$emit("isAddStationeryRecordShowSwitch", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryRecord-topbar.scss";
</style>
